export default (state = true, action) => {
  switch (action.type) {
    case 'MOBILE_DETERMINE':
      return window.innerWidth <= 991;
    default:
      return state;
  }
};
